export default __webpack_public_path__ + "static/media/breakfast_13.f58d9cfb.jpg";